
  import { createRoot } from "react-dom/client";
  import App from "./app/App.tsx";
  import "./styles/index.css";

  // Canonical domain — redirect Azure SWA URL to custom domain in production
const _XYQAR_CANONICAL_ = 'genesis.xyqar.com';
const _xyqar_host_ = window.location.hostname;
if (_xyqar_host_ !== _XYQAR_CANONICAL_ && _xyqar_host_ !== 'localhost' &&
    !_xyqar_host_.startsWith('127.') && !_xyqar_host_.startsWith('192.168.')) {
  window.location.replace('https://' + _XYQAR_CANONICAL_ +
    window.location.pathname + window.location.search + window.location.hash);
}
createRoot(document.getElementById("root")!).render(<App />);
  